<form [formGroup]="filterForm">
  <div class="form-wrapper">
    <div class="div-champ-filtre">
      <!-- Agent filter -->
      @if (agentsList$ | async; as agents) {
        <app-virtual-autocomplete
          label="Agent"
          ariaLabel="Agent"
          [data]="agents"
          [config]="agentConfig"
          [formControl]="agentControl"
        ></app-virtual-autocomplete>
      }

      <!-- Structure hiérarchique filter -->
      <mat-form-field floatLabel="always">
        <mat-label>Structure hiérarchique</mat-label>
        <input type="text" matInput formControlName="structureHierarchique" />
        @if (this.filterForm.get('structureHierarchique')?.value) {
          <button
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="clearStructureHierarchiqueFilter($event)"
            >
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>

      <!-- Fonction filter -->
      <mat-form-field floatLabel="always">
        <mat-label>Fonction</mat-label>
        <input type="text" matInput formControlName="fonction" />
        @if (this.filterForm.get('fonction')?.value) {
          <button
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="clearFonctionFilter($event)"
            >
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>

      <!-- Dernier retour dir (Maxi FC) -->
      <mat-form-field floatLabel="always">
        <mat-label>Dernier retour dir (Maxi FC)</mat-label>
        <input
          type="text"
          formControlName="dateRetourDirection"
          appearance="standard"
          matInput
          [matDatepicker]="pickerDateRetour"
          placeholder="dd/mm/yyyy"
          />
          <mat-datepicker-toggle matIconSuffix [for]="pickerDateRetour"></mat-datepicker-toggle>
          <mat-datepicker #pickerDateRetour></mat-datepicker>
        </mat-form-field>

        <!-- Dates de contrat -->
        <mat-form-field floatLabel="always">
          <mat-label>Date début contrat</mat-label>
          <input
            type="text"
            formControlName="dateDebutContrat"
            appearance="standard"
            matInput
            [matDatepicker]="pickerDateDebut"
            placeholder="dd/mm/yyyy"
            />
            <mat-datepicker-toggle matIconSuffix [for]="pickerDateDebut"></mat-datepicker-toggle>
            <mat-datepicker #pickerDateDebut></mat-datepicker>
          </mat-form-field>

          <mat-form-field floatLabel="always">
            <mat-label>Date fin contrat</mat-label>
            <input
              type="text"
              formControlName="dateFinContrat"
              appearance="standard"
              matInput
              [matDatepicker]="pickerDateFin"
              placeholder="dd/mm/yyyy"
              />
              <mat-datepicker-toggle matIconSuffix [for]="pickerDateFin"></mat-datepicker-toggle>
              <mat-datepicker #pickerDateFin></mat-datepicker>
            </mat-form-field>

            <!-- Info service -->
            @if (servicesList$ | async; as services) {
              <app-virtual-autocomplete
                label="Info service"
                ariaLabel="Service"
                [data]="services"
                [config]="serviceConfig"
                [formControl]="infoServiceControl"
              ></app-virtual-autocomplete>
            }

            <!-- Date entrée organisation -->
            <mat-form-field floatLabel="always">
              <mat-label>Date entrée organisation</mat-label>
              <input
                type="text"
                formControlName="dateEntreeOrganisation"
                appearance="standard"
                matInput
                [matDatepicker]="pickerDateEntree"
                placeholder="dd/mm/yyyy"
                />
                <mat-datepicker-toggle matIconSuffix [for]="pickerDateEntree"></mat-datepicker-toggle>
                <mat-datepicker #pickerDateEntree></mat-datepicker>
              </mat-form-field>

              <!-- Poste budgété 2025 -->
              <mat-form-field floatLabel="always">
                <mat-label>Poste budgété 2025</mat-label>
                <mat-select formControlName="posteBudgete">
                  <mat-option [value]="true">Oui</mat-option>
                  <mat-option [value]="false">Non</mat-option>
                </mat-select>
                @if (this.filterForm.get('posteBudgete')?.value !== null && this.filterForm.get('posteBudgete')?.value !== '') {
                  <button
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="clearPosteBudgeteFilter($event)"
                    >
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </mat-form-field>

              <!-- Type CT -->
              <mat-form-field floatLabel="always">
                <mat-label>Type CT</mat-label>
                <mat-select formControlName="typeCT">
                  @for (type of typeContratList; track type) {
                    <mat-option [value]="type">{{ type.libelle }}</mat-option>
                  }
                </mat-select>
                @if (this.filterForm.get('typeCT')?.value) {
                  <button
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="clearTypeCTFilter($event)"
                    >
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </mat-form-field>

              <!-- Code engagement -->
              <mat-form-field floatLabel="always">
                <mat-label>Code engagement</mat-label>
                <input type="text" matInput formControlName="codeEngagement" />
                @if (this.filterForm.get('codeEngagement')?.value) {
                  <button
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="clearCodeEngagementFilter($event)"
                    >
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </mat-form-field>

              <!-- Info poste -->
              @if (postesList$ | async; as postes) {
                <app-virtual-autocomplete
                  label="Info poste"
                  ariaLabel="Info poste"
                  [data]="postes"
                  [config]="posteConfig"
                  [formControl]="infoPosteControl"
                ></app-virtual-autocomplete>
              }

              <!-- Agent remplacé -->
              @if (agentsList$ | async; as agents) {
                <app-virtual-autocomplete
                  label="Agent remplacé"
                  ariaLabel="Agent remplacé"
                  [data]="agents"
                  [config]="agentConfig"
                  [formControl]="agentRemplaceControl"
                ></app-virtual-autocomplete>
              }

              <!-- Date expiration carte séjour -->
              <mat-form-field floatLabel="always">
                <mat-label>Date expiration carte séjour</mat-label>
                <input
                  type="text"
                  formControlName="dateExpirationCarteSejour"
                  appearance="standard"
                  matInput
                  [matDatepicker]="pickerDateExpiration"
                  placeholder="dd/mm/yyyy"
                  />
                  <mat-datepicker-toggle matIconSuffix [for]="pickerDateExpiration"></mat-datepicker-toggle>
                  <mat-datepicker #pickerDateExpiration></mat-datepicker>
                </mat-form-field>

                <!-- Catégorie poste -->
                <mat-form-field floatLabel="always">
                  <mat-label>Catégorie poste</mat-label>
                  <mat-select formControlName="categoriePoste">
                    @for (categorie of categoriePosteList; track categorie) {
                      <mat-option [value]="categorie">{{ categorie.code }}</mat-option>
                    }
                  </mat-select>
                  @if (this.filterForm.get('categoriePoste')?.value) {
                    <button
                      matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="clearCategoriePosteFilter($event)"
                      >
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                </mat-form-field>

                <!-- Grade -->
                <mat-form-field floatLabel="always">
                  <mat-label>Grade</mat-label>
                  <input type="text" matInput formControlName="grade" />
                  @if (this.filterForm.get('grade')?.value) {
                    <button
                      matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="clearGradeFilter($event)"
                      >
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                </mat-form-field>

                <!-- Taux sit.admin -->
                <mat-form-field floatLabel="always">
                  <mat-label>Taux sit.admin</mat-label>
                  <input type="text" matInput formControlName="tauxSitAdmin" />
                  @if (this.filterForm.get('tauxSitAdmin')?.value) {
                    <button
                      matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="clearTauxSitAdminFilter($event)"
                      >
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                </mat-form-field>

                <!-- Statut -->
                <mat-form-field floatLabel="always">
                  <mat-label>Statut</mat-label>
                  <mat-select formControlName="statut">
                    <mat-option [value]="true">Renouvellement en cours</mat-option>
                    <mat-option [value]="false">A renouveler</mat-option>
                  </mat-select>
                  @if (this.filterForm.get('statut')?.value !== null && this.filterForm.get('statut')?.value !== '') {
                    <button
                      matSuffix
                      mat-icon-button
                      aria-label="Clear"
                      (click)="clearStatutFilter($event)"
                      >
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                </mat-form-field>
              </div>

              <div class="div-filtre-bouton">
                <button mat-stroked-button type="reset" class="bt-table-effacer" (click)="resetForm()">
                  <mat-icon>delete</mat-icon> Effacer tous les filtres
                </button>
                <button mat-raised-button color="primary" class="bt-table-filtrer" (click)="applyFilters()">
                  Filtrer
                </button>
              </div>
            </div>
          </form>
